import * as Sentry from '@sentry/browser';
import { callWhenIsNotDevelopment } from '../utils/enviroment';

const init = () =>
  callWhenIsNotDevelopment(() =>
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      debug: Boolean(process.env.REACT_APP_SENTRY_DEBUG),
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
      blacklistUrls: [/localhost/i, /judopay\.min\.js/i],
    })
  );

const captureException = exception => callWhenIsNotDevelopment(() => Sentry.captureException(exception));

export default {
  init,
  captureException,
};
